module.exports = __webpack_public_path__ + "img/Tianyuan_type12.b45d15cd.png";